import type {SearchState} from '@/types/models/creator-crm/creatorCrm';
import type {
  ActiveFilterWithRemovalContext,
  GroupedActiveFilter,
} from './useActiveFiltersBar';

export type SearchChipItem = {
  type: 'searchChip';
  searchType: SearchState['type'];
  value: string;
  filterName: string;
};

export type FilterItem = {
  type: 'filter';
  data: ActiveFilterWithRemovalContext;
};

export type DisplayItem = SearchChipItem | FilterItem;

export type GroupedDisplayItems = {
  groupKey: string;
  items: DisplayItem[];
};

/**
 * Converts grouped active filters (from store) to GroupedDisplayItems for display.
 */
export function groupedDisplayItemsFromFilters(
  groups: GroupedActiveFilter[]
): GroupedDisplayItems[] {
  return groups.map(({groupKey, filters}) => ({
    groupKey,
    items: filters.map((f) => ({type: 'filter' as const, data: f})),
  }));
}
